/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdCheckboxGroupProps, TdCheckboxProps } from './type';

export const checkboxDefaultProps: TdCheckboxProps = {
  checkAll: false,
  defaultChecked: false,
  disabled: undefined,
  indeterminate: false,
  readonly: undefined,
};

export const checkboxGroupDefaultProps: TdCheckboxGroupProps = {
  disabled: undefined,
  max: undefined,
  readonly: undefined,
  defaultValue: [],
};
